import { Component, Inject, Optional, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';
import { GoToEngagePage, ViewOnCalendar } from 'spotlight-ui/app/actions/engage';
import { AnalyticsService } from 'spotlight-ui/app/core/analytics';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CampaignType } from '../../../models/engage/campaign-details.model';
import { ActionType } from '../../../discover/dependencies/digital-marketing-automation-source';

@Component({
  selector: 'campaign-sent-confirmation-modal',
  templateUrl: './campaign-sent-confirmation-modal.component.html',
  styleUrls: ['./campaign-sent-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CampaignSentConfirmationModalComponent {
  protected readonly CampaignType = CampaignType;
  protected readonly ActionType = ActionType

  public campaign;

  constructor(private readonly analytics: AnalyticsService,
                private readonly store: Store<fromRoot.State>,
                @Optional() @Inject(MAT_DIALOG_DATA) private readonly dialogData: any,
                public dialogRef: MatDialogRef<CampaignSentConfirmationModalComponent>
  ) {
    this.campaign = this.dialogData;
  }

  public backToEngage() {
    this.store.dispatch(new GoToEngagePage());
    this.analytics.sendEvent(
      'Navigated to Engage After Successful send',
      {
        'Type': this.campaign.type
      }
    );
  }

  public goBack() {
    this.dialogRef.close();
    // On error, stay on the current form so the user can select a new time
    if (this.campaign?.error) {
      return;
    }
    if (this.campaign.isMobile) {
      globalThis.history.go(-2)
    } else {
      globalThis.history.back();
    }

  }

  public goToCalendar() {
    let queryParams = {
      id: this.campaign.campaignID,
      campaignEngineV2: true,
      ...(this.campaign.type === CampaignType.Automation && { type: this.campaign.type }),
    };
    this.store.dispatch(new ViewOnCalendar(queryParams));
    this.analytics.sendEvent(
      'Navigated to Engage Details Page After Send',
      {
        'Type': this.campaign.type,
        'Mode': 'review',
        'Id': this.campaign.campaignID
      }
    );

  }
}
